export default "__VITE_ASSET__B5VL2TUS__"